<template>
  <el-dialog
    :visible.sync="dialogVisible"
    append-to-body
    @click.native="handleModalClick"
    :before-close="handleClose">
    <div class="dialog-container">
      <!--全身-->
      <Live2d
        v-if="showType === '0_0'"
        :key="dataSource.key"
        :dataSource="dataSource.live2d.full"
        type="full"
        :operationType="operationType"
        animation="idle"
        :live2dId="live2dId.full"
      />
      <!--live2d-->
      <Live2d
        v-if="showType === '0_1'"
        :key="dataSource.key"
        :dataSource="dataSource.live2d.cover"
        type="cover"
        :operationType="operationType"
        animation="cover_idle"
        :live2dId="live2dId.cover"
      />
      <!--瞄准-->
      <Live2d
        v-if="showType === '0_2'"
        :key="dataSource.key"
        :dataSource="dataSource.live2d.aim"
        type="aim"
        :operationType="operationType"
        animation="aim_idle"
        :live2dId="live2dId.aim"
      />
      <!--立绘-->
      <LH v-if="showType === '1'" :key="dataSource.key" :dataSource="dataSource.lh"/>
      <!--sd模型-->
      <SDModel v-if="showType === '3'" :key="dataSource.key" :dataSource="dataSource.SDModel"/>
      <!--大招动画-->
      <Dzdh v-if="showType === '4'" :key="dataSource.key" :dataSource="dataSource.dzdh"/>

      <div class="options">
        <el-tooltip class="item" effect="dark" :content="operationType === 0 ? '小图' : '大图'" placement="right-start">
          <div class="options-item">
            <img v-if="operationType === 1" class="icon" src="@/assets/nikke_imgs/live2d-amplify-icon.png" alt="" @click="handleOpt(0)"/>
            <img v-else class="icon" src="@/assets/nikke_imgs/live2d-reduce-icon.png" alt="" @click="handleOpt(1)"/>
          </div>
        </el-tooltip>

        <div class="options-item" @click="downloadImage" v-if="showType === '1'">
          <img class="icon" src="@/assets/nikke_imgs/live2d-download-icon.png" alt=""/>
        </div>

        <el-tooltip v-else class="item" effect="dark" content="当前图像不支持下载哦" placement="right-start">
          <div class="options-item">
            <img class="icon" src="@/assets/nikke_imgs/live2d-download-icon.png" alt=""/>
          </div>
        </el-tooltip>

      </div>
    </div>
  </el-dialog>
</template>
<script>
import Live2d from './live2d.vue'
import LH from './lh.vue'
import SDModel from './sdModel.vue'
import Dzdh from './dzdh.vue'

export default {
  components: {
    Live2d,
    LH,
    SDModel,
    Dzdh
  },
  data() {
    return {
      dialogVisible: false,
      showType: "0_0",
      roleName: '',
      dataSource: {
        live2d: {
          full: "",
          cover: "",
          aim: ""
        }
      },
      live2dId: {
        full: "__spine_player_container__full",
        cover: "__spine_player_container__cover",
        aim: "__spine_player_container__aim"
      },
      operationType: 1
    }
  },
  methods: {
    handleModalClick(event) {
      if (event.target.classList.contains('el-dialog__body')) {
        this.handleClose();
      }
    },
    handleClose() {
      this.dialogVisible = false
    },
    open(dataSource, showType, roleName) {
      console.log(roleName);
      this.roleName = roleName
      this.dataSource = dataSource
      this.showType = showType
      this.dialogVisible = true
    },
    downloadImage() {
      const linkUrl = this.dataSource.lh.value;
      let image = new Image();
      const _this = this
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        let context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        let url = canvas.toDataURL("image/png");
        let a = document.createElement("a");
        a.download = _this.roleName + '.png' || "photo.png";
        a.href = url;
        a.dispatchEvent(new MouseEvent("click"));
      };
      image.src = linkUrl;
    },
    handleOpt(type){
      if (this.showType.includes("0_")) {
        this.operationType = type
      }
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .el-dialog {
  margin-top: 0 !important;
  height: 100vh;
  width: 100vw;
  box-shadow: none;
  background: rgba(0, 0, 0, 0.8);

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    height: 100vh;
    padding: 0;
    display: flex;
    justify-content: center;
    background: transparent;

    .dialog-container {
      position: relative;
      width: 50vw;
      height: 100%;
      display: flex;
      justify-content: center;
      background: transparent;
    }

    .options {
      position: absolute;
      bottom: 32px;
      right: -50px;

      .options-item {
        position: relative;
        z-index: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 52px;
        height: 52px;
        margin-bottom: 10px;
        cursor: pointer;

        .icon {
          position: relative;
          z-index: 1;
          width: 32px;
          height: 32px;
        }

        &::before {
          position: absolute;
          z-index: 1;
          content: "";
          display: block;
          width: 32px;
          height: 32px;
          border-radius: 6px;
          transform: rotate(45deg);
          border: 2px solid #c1cfdd;
          background: linear-gradient(180deg, #464949 0%, #313131 100%);
        }

        &.active {
          &::before {
            background: linear-gradient(135deg, #76c6fe 0%, #4b9cea 100%);
          }
        }
      }
    }
  }
}

</style>
